@let wallet = this.wallet();

<div class="kr-wallet-details__header" data-testid="wallet_details_header">
  <h4
    class="kr-wallet-details__header-text"
    data-testid="wallet_details_header_text">
    {{ wallet?.name || initialWalletName }}
  </h4>

  <button
    class="kr-wallet-details__header-btn-close"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    data-testid="wallet_details_btn_close"
    [onlyIcon]="true"
    (click)="close()">
    <fu-icon iconName="close-square" data-testid="wallet_details_icon_close" />
  </button>
</div>

<div class="kr-wallet-details__body" data-testid="wallet_details_body">
  @if (isDeleteWalletSuccess()) {
    <kr-delete-wallet-success
      [wallet]="wallet"
      (closed)="close()"
      data-testid="wallet_details_delete_success" />
  } @else if (deleteWalletError()) {
    <kr-delete-wallet-failed
      [wallet]="wallet"
      [errorMessage]="
        deleteWalletError()?.originalError.error.error_description
      "
      (closed)="close()"
      data-testid="wallet_details_delete_failed" />
  } @else {
    <nav class="kr-tabs" data-testid="wallet_details_tabs">
      <div
        class="kr-tabs__tab"
        [class.kr-tabs__tab_active]="tab === 'wallet'"
        (click)="setTab('wallet')"
        translate="walletDetails.tab.wallet"
        data-testid="wallet_details_tab_wallet"></div>

      <div
        class="kr-tabs__tab"
        [class.kr-tabs__tab_active]="tab === 'transactions'"
        (click)="setTab('transactions')"
        translate="walletDetails.tab.transactions"
        data-testid="wallet_details_tab_transactions"></div>

      <div
        class="kr-tabs__tab"
        [class.kr-tabs__tab_active]="tab === 'users'"
        (click)="setTab('users')"
        translate="walletDetails.tab.users"
        data-testid="wallet_details_tab_users"></div>
    </nav>

    @if (wallet) {
      @switch (tab) {
        @case ('wallet') {
          <div
            class="kr-wallet-details__wallet"
            data-testid="wallet_details_wallet">
            <kr-wallet-card
              [wallet]="wallet"
              (edit)="openWalletEditDialog()"
              large
              withEditBtn
              data-testid="wallet_details_wallet_card" />

            @if (wallet?.secondaryWalletCoin?.symbol) {
              <div
                class="kr-wallet-details__wallet-row"
                data-testid="wallet_details_wallet_row_secondary_balance">
                <div
                  class="kr-details"
                  data-testid="wallet_details_secondary_balance_details">
                  <label
                    class="kr-details__label"
                    data-testid="wallet_details_secondary_balance_label">
                    {{ 'walletDetails.label.balance' | translate }}
                    {{ wallet.secondaryWalletCoin.symbol }}
                  </label>

                  <span
                    class="kr-details__value"
                    [title]="
                      wallet.networkBalance
                        | balanceFormat: wallet.secondaryWalletCoin.symbol
                    "
                    data-testid="wallet_details_secondary_balance_value">
                    {{
                      wallet.networkBalance
                        | balanceFormat: wallet.secondaryWalletCoin.symbol
                    }}
                  </span>
                </div>
              </div>
            }

            <div
              class="kr-wallet-details__wallet-row"
              data-testid="wallet_details_wallet_row_main">
              <div
                class="kr-details"
                data-testid="wallet_details_address_details">
                <label
                  class="kr-details__label"
                  data-testid="wallet_details_address_label">
                  {{ wallet.coin?.name }}
                  {{ 'walletDetails.label.address' | translate }}
                </label>

                <span
                  class="kr-details__value kr-details__value_hover"
                  (click)="clipboard.copy(wallet.address)"
                  data-testid="wallet_details_address_value">
                  {{ wallet.address }}
                  <fu-icon
                    iconName="copy"
                    size="16"
                    data-testid="wallet_details_icon_copy_address" />
                </span>
              </div>

              <div class="kr-details" data-testid="wallet_details_id_details">
                <label
                  class="kr-details__label"
                  data-testid="wallet_details_id_label">
                  {{ 'walletDetails.label.id' | translate }}
                </label>

                <span
                  class="kr-details__value kr-details__value_hover"
                  (click)="clipboard.copy('' + wallet.id)"
                  data-testid="wallet_details_id_value">
                  {{ wallet.id }}
                  <fu-icon
                    iconName="copy"
                    size="16"
                    data-testid="wallet_details_icon_copy_id" />
                </span>
              </div>
            </div>
          </div>

          <div class="kr-actions" data-testid="wallet_details_actions">
            <button
              type="button"
              fuButton
              size="m"
              uiType="primary"
              (click)="openTransferDialog()"
              translate="walletDetails.btn.transfer"
              data-testid="wallet_details_btn_transfer"></button>

            <button
              type="button"
              fuButton
              size="m"
              uiType="primary"
              (click)="openMassPayOutDialog()"
              translate="walletDetails.btn.massPayOut"
              data-testid="wallet_details_btn_mass_payout"></button>

            <button
              type="button"
              fuButton
              size="m"
              uiType="primary"
              (click)="openExchangeDialog()"
              data-testid="wallet_details_btn_exchange">
              <fu-icon
                iconName="exchange"
                size="20"
                data-testid="wallet_details_icon_exchange" />
              {{ 'exchange.dialog.title' | translate }}
            </button>
          </div>
        }
        @case ('transactions') {
          <kr-transactions
            class="kr-wallet-details__tab-container"
            [wallet]="wallet"
            [providerId]="providerId"
            [isolated]="true"
            data-testid="wallet_details_tab_content_transactions" />
        }
        @case ('users') {
          <kr-wallet-users
            class="kr-wallet-details__tab-container"
            [wallet]="wallet"
            data-testid="wallet_details_tab_content_users" />
        }
      }
    }
  }
</div>
